"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripsThemedPage = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
let DayTripsThemedPage = class DayTripsThemedPage {
    _id = (0, uuid_1.v4)();
    slug;
    status = legacy_enums_1.DayTripsThemedPageStatus.Draft;
    title;
    subHeader;
    imageUrl;
    dayTripIds = [];
};
exports.DayTripsThemedPage = DayTripsThemedPage;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "slug", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripsThemedPageStatus),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "title", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "subHeader", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripsThemedPage.prototype, "imageUrl", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Array)
], DayTripsThemedPage.prototype, "dayTripIds", void 0);
exports.DayTripsThemedPage = DayTripsThemedPage = __decorate([
    (0, typeorm_1.Entity)("dayTripsThemedPages")
], DayTripsThemedPage);
//# sourceMappingURL=DayTripsThemedPage.js.map